/*
 * The brand's mark, wherever it appears.
 *
 * On a multi-brand deployment the shipped logo belongs to THIS deployment's
 * brand, so a tenant that has not supplied artwork of its own must not borrow
 * it — a Viking applicant seeing Broker Kong's mark is worse than seeing no
 * mark at all. Those brands get a monogram in their own accent colour, which
 * is never wrong and always legible.
 *
 * Every surface (form rail, console shell and sign-in, printed summary, broker
 * portal) draws the mark through here so there is one answer to "what do we
 * show when there is no logo", instead of four.
 */
import React from "react";
import { resources } from "../resources.js";
import { BRAND } from "../brand.js";

export function BrandMark({ size = 36, radius = 10, className, style }) {
  const box = {
    width: size, height: size, borderRadius: radius, overflow: "hidden", flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    ...(resources.logo ? null : { background: "var(--coral, var(--pink-500, #333))" }),
    ...style,
  };
  if (resources.logo) {
    return (
      <div className={className} style={box}>
        <img src={resources.logo} alt={BRAND.name} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
      </div>
    );
  }
  return (
    <div className={className} style={box} role="img" aria-label={BRAND.name}>
      <span style={{ fontFamily: "var(--font-display, inherit)", fontWeight: 800, fontSize: Math.round(size * 0.46), color: "#fff", lineHeight: 1 }}>
        {String(BRAND.name || "?").trim().charAt(0).toUpperCase()}
      </span>
    </div>
  );
}
